import Link from 'next/link';

import { Takeover as TakeoverData } from 'services/freeform';

import styles from './takeover.module.scss';

type TakeoverProps = {
	data: TakeoverData;
};

const TakeoverPanel = ({ data }: TakeoverProps) => {
	const content = (
		<>
			{data.icon ? (
				<div className={styles.icon}>
					<img
						className={styles.icon}
						src={data.icon}
						alt={data.title}
						aria-hidden="true"
					/>
				</div>
			) : null}

			<h2
				id="takeover-heading"
				className={`${styles.title} hero-small uppercase`}
			>
				{data.title}
			</h2>
		</>
	);

	if (!data.link?.url) {
		return <div className={styles.panel}>{content}</div>;
	}

	return (
		<Link
			href={data.link.url}
			className={styles.panel}
			target={data.link.target}
			rel={data.link.rel}
			aria-label={data.link.name || data.title}
		>
			{content}
		</Link>
	);
};

export const Takeover = ({ data }: TakeoverProps) => {
	const desktopImage = data.desktopImage || data.image;

	return (
		<section
			className={`${styles.root} shadow-secondary-onlight-xlarge`}
			aria-labelledby="takeover-heading"
		>
			<picture className={styles.background}>
				{data.desktopImage ? (
					<source media="(min-width: 62rem)" srcSet={desktopImage} />
				) : null}
				<img src={data.image} alt="" />
			</picture>

			<div className={`container ${styles.content}`}>
				<div className="row">
					<div className="col-12">
						<TakeoverPanel data={data} />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Takeover;
